/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Monday_May_119Inputs */

const en__field_enum_monday_may_119 = /** @type {(inputs: _Field_Enum_Monday_May_119Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monday, May 11, 2026`)
};

const de__field_enum_monday_may_119 = /** @type {(inputs: _Field_Enum_Monday_May_119Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montag, 11.05.2026`)
};

/**
* | output |
* | --- |
* | "Monday, May 11, 2026" |
*
* @param {_Field_Enum_Monday_May_119Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_monday_may_119 = /** @type {((inputs?: _Field_Enum_Monday_May_119Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Monday_May_119Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_monday_may_119(inputs)
	return de__field_enum_monday_may_119(inputs)
});
export { _field_enum_monday_may_119 as "_field_enum_MONDAY_MAY_11" }